import React, { useState, useMemo } from 'react';
import AuthContext from './AuthContext';

export default function AuthContextProvider(props) {

    const [isAuth, setIsAuth] = useState(false);
    const [isClientAuth, setIsClientAuth] = useState(false);
    const [isAgentAuth, setIsAgentAuth] = useState(false);
    const [finishedLoading, setFinishedLoading] = useState(false);
    const [userDetail, setUserDetail] = useState({});
    const [token, setToken] = useState("");
    const [clientToken, setClientToken] = useState("")

    const context = useMemo(() => {

        return {


            getIsAuth: () => {
                return isAuth;
            },
            updateIsAuth: (value) => {
                return setIsAuth(value);
            },
            getIsClientAuth: () => {
                return isClientAuth;
            },
            updateIsClientAuth: (value) => {
                return setIsClientAuth(value);
            },
            getIsAgentAuth: () =>{
                return isAgentAuth;
            },
            updateIsAgentAuth: (value) => {
                return setIsAgentAuth(value)
            },
            getFinishedLoading: () => {
                return finishedLoading;
            },
            updateFinishedLoading: (value) => {
                return setFinishedLoading(value);
            },
            getUserDetail: () => {
                return userDetail;
            },
            updateUserDetail: (value) => {
                return setUserDetail(value);
            },
            getToken: () => {
                return token;
            },
            updateToken: (value) => {
                return setToken(value);
            },
            getClientToken: () => {
                return clientToken;
            },
            updateClientToken: (value) => {
                return setClientToken(value);
            }
        };

    }, [isAuth, isClientAuth, isAgentAuth, userDetail, token, clientToken, finishedLoading]);

    return (
        <>
            <AuthContext.Provider value={context}>
                {props.children}
            </AuthContext.Provider>
        </>
    );
};